export const MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 868;
